(() => {
  if (window.mathersQuantityControls) return;
  window.mathersQuantityControls = true;
  function sync(control) {
    const input = control.querySelector('input');
    const value = Number(input.value);
    control.querySelector('[data-quantity-step="-1"]').disabled = input.disabled || (input.min !== '' && value <= Number(input.min));
    control.querySelector('[data-quantity-step="1"]').disabled = input.disabled || (input.max !== '' && value >= Number(input.max));
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const control = button.closest('[data-quantity-control]');
    const input = control.querySelector('input');
    if (input.disabled || input.readOnly) return;
    if (!input.value || !Number.isFinite(Number(input.value))) input.value = input.min || '0';
    event.preventDefault();
    const step = Number(input.step) > 0 ? Number(input.step) : 1;
    const minimum = input.min !== '' ? Number(input.min) : 0;
    const maximum = input.max !== '' ? Number(input.max) : Infinity;
    input.value = String(Math.min(maximum, Math.max(minimum, Number(input.value) + Number(button.dataset.quantityStep) * step)));
    input.dispatchEvent(new Event('input', {bubbles: true}));
    input.dispatchEvent(new Event('change', {bubbles: true}));
    sync(control);
  });
  document.addEventListener('input', event => {
    const control = event.target.closest('[data-quantity-control]');
    if (control) sync(control);
  });
  const init = () => document.querySelectorAll('[data-quantity-control]').forEach(sync);
  init(); document.addEventListener('shopify:section:load', init);
})();